<template>
  <div>
    <ValidationObserver v-slot="{ invalid }" ref="observer">
      <form @submit.stop>
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} bước chuyển ticket</h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/ticket-transition')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button type="button" class="btn btn-success btn-primary ml-2" @click="submitRequest">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="category" name="Mã danh mục Ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mã danh mục Ticket<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      v-model="dataRequest.category"
                      :options="dataCategoryTypeCode"
                      @change="fetchDataCurrentState"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="isFromAll" name="Từ tất cả hiện trạng?">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Từ tất cả hiện trạng?<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.isFromAll" :options="optionIsFromAll" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                vid="isFromNull"
                name="Từ tất cả hiện trạng NULL?"
                :persist="true"
                v-if="displayIsFromNull"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Từ tất cả hiện trạng NULL?<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.isFromNull" :options="optionIsFromNull" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                vid="fromState"
                name="Từ hiện trạng"
                :persist="true"
                v-if="displayFromState"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Từ hiện trạng<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.fromState" :options="dataCurrentState" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="toState" name="Từ hiện trạng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Đến hiện trạng<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.toState" :options="dataCurrentState" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|max30Character" vid="name" name="Tên bước chuyển">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Tên bước chuyển<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control text-left" v-model="dataRequest.name" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_2" vid="note" name="Mô tả">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Mô tả </label>
                  <div class="col-sm-9">
                    <textarea
                      class="form-control text-left"
                      rows="4"
                      v-model="dataRequest.note"
                      style="resize: none"
                    ></textarea>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="transitionCondition" name="Điều kiện đầu vào">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Điều kiện đầu vào </label>
                  <div class="col-sm-9">
                    <Select2
                      v-model="dataRequest.transitionCondition"
                      :options="optionTransitionCondition"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="postFunction" name="Lệnh tự động">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Lệnh tự động </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.postFunction" :options="optionPostFunction" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import { TicketService } from '@/services/ticket.service'
  import cloneDeep from 'lodash/cloneDeep'

  export default {
    data() {
      return {
        dataRequest: {
          category: '',
          fromState: '',
          isFromAll: '',
          isFromNull: '',
          name: '',
          note: '',
          postFunction: '',
          toState: '',
          transitionCondition: '',
        },
        showLoading: false,
        dataCategoryTypeCode: [],
        optionIsFromAll: [
          { id: true, text: 'Có' },
          { id: false, text: 'Không' },
        ],
        optionIsFromNull: [
          { id: true, text: 'Có' },
          { id: false, text: 'Không' },
        ],
        optionTransitionCondition: [
          { id: 'FIELD_ASSIGNEE', text: 'assignee' },
          { id: 'FIELD_SUPERVISOR', text: 'supervisor' },
          { id: 'ROLE_AFS_LEADER', text: 'Aftersale leader' },
        ],
        optionPostFunction: [
          { id: 'MOVE_COMPLETE_SUCCESS', text: 'MOVE_COMPLETE_SUCCESS' },
          { id: 'MOVE_COMPLETE_FAIL', text: 'MOVE_COMPLETE_FAIL' },
          { id: 'MOVE_COMPLETE_OTHER', text: 'MOVE_COMPLETE_OTHER' },
          { id: 'MOVE_CANCEL_SUCCESS', text: 'MOVE_CANCEL_SUCCESS' },
          { id: 'MOVE_CANCEL_FAIL', text: 'MOVE_CANCEL_FAIL' },
          { id: 'MOVE_CANCEL_OTHER', text: 'MOVE_CANCEL_OTHER' },
        ],
        dataCurrentState: [],
        displayIsFromNull: true,
        displayFromState: true,
      }
    },
    async created() {
      TicketService.fetchCategory()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataCategoryTypeCode = s))
      await this.fetchDataCurrentState()
      await this.fetchData()
    },
    watch: {
      'dataRequest.isFromAll': function (value) {
        if (value == 'true') {
          this.displayIsFromNull = false
          this.displayFromState = false
        }
        if (value == 'false') {
          this.displayIsFromNull = true
          this.displayFromState = true
        }
      },
      'dataRequest.isFromNull': function (value) {
        if (value == 'true') {
          this.displayFromState = false
        }
        if (value == 'false') {
          this.displayFromState = true
        }
      },
    },
    methods: {
      async submitRequest() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        if (this.dataRequest.id) {
          await this.update()
        } else {
          await this.create()
        }
      },
      preareDataEdit(params) {
        const data = params
        if (data.isFromAll == 'true') {
          data.isFromAll = true
          data.isFromNull = null
          data.fromState = ''
        }
        if (data.isFromNull == 'true') {
          data.isFromAll = false
          data.isFromNull = true
          data.fromState = ''
        }
        return data
      },
      async create() {
        try {
          this.showLoading = true

          const params = cloneDeep(this.dataRequest)
          const body = this.preareDataEdit(params)

          const response = await TicketService.createTransitionTicket(body)
          if (response.code === 1000) {
            this.dataRequest.id = response.data.id
            this.showSuccessMx('Thêm mới bước chuyển ticket thành công').then(() =>
              this.$router.push(`/ticket-transition/${response.data.id}`)
            )
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async update() {
        try {
          this.showLoading = true

          const params = cloneDeep(this.dataRequest)
          const body = this.preareDataEdit(params)

          const response = await TicketService.updateTransitionTicket(body)
          if (response.code === 1000) {
            this.dataRequest.id = response.data.id
            this.showSuccessMx('Cập nhật bước chuyển ticket thành công').then(() =>
              this.$router.push(`/ticket-transition/${this.dataRequest.id}`)
            )
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        const transitionId = this.$route.params.id
        if (transitionId) {
          try {
            this.showLoading = true
            const res = await TicketService.detailTransitionTicket({ id: transitionId })
            if (res.code === 1000) {
              this.dataRequest = {
                id: res.data.id ? res.data.id : '',
                category: res.data.category ? res.data.category : '',
                fromState: res.data.fromState ? res.data.fromState : '',
                name: res.data.name ? res.data.name : '',
                note: res.data.note ? res.data.note : '',
                postFunction: res.data.postFunction ? res.data.postFunction : '',
                toState: res.data.toState ? res.data.toState : '',
                transitionCondition: res.data.transitionCondition
                  ? res.data.transitionCondition
                  : '',
                isFromAll: '',
                isFromNull: '',
              }
              await this.fetchDataCurrentState()
              if (res.data.isFromAll === true) {
                this.dataRequest.isFromAll = 'true'
              } else if (res.data.isFromAll === false) {
                this.dataRequest.isFromAll = 'false'
              } else {
                this.dataRequest.isFromAll = ''
              }
              if (res.data.isFromNull === true) {
                this.dataRequest.isFromNull = 'true'
              } else if (res.data.isFromNull === false) {
                this.dataRequest.isFromNull = 'false'
              } else {
                this.dataRequest.isFromNull = ''
              }
            } else {
              this.showFailMx(res.message)
            }
          } catch (error) {
            this.showFailMx(error.message ?? error)
          } finally {
            this.showLoading = false
          }
        }
      },
      async fetchDataCurrentState() {
        try {
          this.showLoading = true
          let params = {}
          if (this.dataRequest.category) {
            params = { applyFor: [this.dataRequest.category] }
          }
          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState = response.data.map(s => ({ id: s.code, text: s.name })) ?? []
            this.dataCurrentState.push({ text: 'Khác', id: 'OTHER' })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
          this.selectedTicket = []
        }
      },
    },
  }
</script>
<style scoped></style>
